import { Abac } from '@gunosy/media-admin-components'
import React, { Fragment } from 'react'
import { Nav, NavItem, NavLink } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import { SelectIsInhouse, SelectLoggedInUser } from '../../store/loggedInUser'
import { UIStateActions } from '../../store/uiState'
import { Menu } from './NavItems'

const VerticalNav: React.FC = () => {
  const dispatch = useDispatch()
  const loggedInUser = useSelector(SelectLoggedInUser)
  const isInhouse = useSelector(SelectIsInhouse)
  const currentHash = window.location.hash

  const handleNavClick = () => {
    dispatch(UIStateActions.setEnableClosedSidebar(false))
    dispatch(UIStateActions.setEnableMobileMenu(false))
  }

  return (
    <Fragment>
      <h5
        className="app-sidebar__heading"
        style={{
          color: '#222',
          padding: '2px 0 8px',
          fontSize: '1rem',
          textTransform: 'initial',
        }}
      >
        {'Gunosy Publisher Center'}
      </h5>
      {Menu.map((ms, sectionIndex) => {
        const viewableItems = ms.items.filter(i => {
          if (!i.resource) {
            return true
          }
          const hide = i.hide ? i.hide : () => false
          return loggedInUser.abac.can(Abac.Action.List, i.resource) && !hide(isInhouse, loggedInUser)
        })

        if (viewableItems.length > 0) {
          return (
            <div key={sectionIndex}>
              <h5 className="app-sidebar__heading">{ms.title}</h5>
              <Nav vertical className="vertical-nav-menu">
                {viewableItems.map((item, itemIndex) => {
                  const isActive =
                    item.to &&
                    (currentHash === item.to ||
                      (item.to === '#/reports/dashboard' && currentHash === '#/reports/dashboard/') ||
                      (item.to === '#/reports/dashboard' &&
                        (currentHash === '' || currentHash === '#' || currentHash === '#/')))
                  return (
                    <NavItem key={itemIndex}>
                      <NavLink
                        href={item.externalLink ? item.to : undefined}
                        target={item.externalLink ? '_blank' : undefined}
                        rel={item.externalLink ? 'noopener noreferrer' : undefined}
                        onClick={
                          item.externalLink
                            ? undefined
                            : () => {
                                handleNavClick()
                                if (item.to) {
                                  window.location.hash = item.to.replace('#', '')
                                }
                              }
                        }
                        style={{
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          padding: '0 1.5rem 0 8px',
                          borderRadius: '4px',
                          margin: '2px 8px',
                          transition: 'background-color 0.2s ease',
                          position: 'relative',
                          backgroundColor: isActive ? 'rgba(0, 123, 255, 0.2)' : 'transparent',
                          color: isActive ? '#007bff' : '#343a40',
                        }}
                        className="nav-item-hover"
                      >
                        <item.icon
                          style={{
                            position: 'absolute',
                            left: '8px',
                            fontSize: '1.5em',
                            color: isActive ? '#007bff' : 'inherit',
                          }}
                        />
                        <span
                          style={{
                            marginLeft: '32px',
                            color: isActive ? '#007bff' : 'inherit',
                          }}
                        >
                          {item.label}
                        </span>
                      </NavLink>
                    </NavItem>
                  )
                })}
              </Nav>
            </div>
          )
        }
        return null
      })}
    </Fragment>
  )
}

export default VerticalNav
